import axios from "axios";
import API from "../api";


export const BookingNotesModule = {
  state: {
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getBookingNotes({
      commit
    }, bookingId) { 
      return new Promise(async (resolve, reject) => {
        commit("getBookingNotesRequest");
        return axios
          // .get(`${API.BASE_URL}${API.BOOKINGS}${API.NOTES}/${bookingId}`, API.RequestHeaders()) controller is incomplete
          .get(`${API.BASE_URL}${API.BOOKINGS}${API.NOTES}`, API.RequestHeaders()) 
          .then(response => {
            if (response.status === 200) {
              commit("getBookingNotesSuccess", response.data);
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("bookingNoteError", error);
            reject(error);
          });
      });
    },
    createBookingNote({
      commit
    }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createBookingNoteRequest");
        return axios
          .post(`${API.BASE_URL}${API.BOOKINGS}${API.NOTES}`, record, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createBookingNoteSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("bookingBookingError", error);
            reject(error);
          });
      });
    },
    deleteBookingNote({
      commit
    }, recordId) { 
      return new Promise(async (resolve, reject) => {
        commit("deleteBookingNoteRequest");
        return axios
          .delete(`${API.BASE_URL}${API.BOOKINGS}${API.NOTES}/${recordId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteBookingNoteSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("bookingBookingError", error);
            reject(error);
          });
      });
    }
  },
  mutations: {
    getBookingNotesRequest(state) {
      state.isRequesting = true;
    },
    getBookingNotesSuccess(state, payload) {
      state.isRequesting = false;
    },
    createBookingNoteRequest(state) {
      state.isRequesting = true;
    },
    createBookingNoteSuccess(state, payload) {
      state.isRequesting = false;
    },
    bookingNoteError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteBookingNoteRequest(state) {
      state.isRequesting = true;
    },
    deleteBookingNoteSuccess(state, recordId) {
      state.isRequesting = false;
    }
  }
};